<template>
    <div class="flex items-center justify-end space-x-4">
        <!-- <ui-button-new small icon="fa fa-undo">Undo</ui-button-new> -->
        <!-- <ui-button-new small icon="fa fa-repeat">Redo</ui-button-new> -->
        <div class="flex">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-72">
                <template #default="{ toggle }">
                    <ui-button-new @click="toggle" small primary>
                        Actions
                        <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                    </ui-button-new>
                </template>

                <template #menu="{ close }">
                    <ui-dropdown-item icon="fa fa-file-plus" @click="$store.snapshot(); close();">Create a Revision</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <!-- <ui-dropdown-item icon="fa fa-eye">Preview</ui-dropdown-item> -->
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="estimate._links.download" target="_blank">Download</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="estimate._links.download_no_rates" target="_blank">Download (No Rate)</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-arrow-down" :href="estimate._links.download_no_costs" target="_blank">Download (No Costs)</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-clipboard-list" @click="$modals.open('estimates-old-page-material-list-sidepage', { context: estimate, contextType: 'estimate' }); close();">See material list</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="fa fa-envelope" @click="createRemoteInvite(close)">Email to Client</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-eraser" v-if="estimate.secured" @click="unsecureEstimate(close)">Unsecure Estimate</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-check" v-else @click="secureEstimate(close)">Mark as Secured</ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-eraser" v-if="estimate.declined" @click="undeclineEstimate(close)">Undecline Estimate</ui-dropdown-item>
                    <ui-dropdown-item icon="fa fa-times" v-else @click="declineEstimate(close)">Mark as Declined</ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-clone" @click="$modals.open('estimates-old-page-copy-to-modal'); close();">Copy To...</ui-dropdown-item>
                    <template v-if="$store.state.admin">
                        <ui-dropdown-item icon="fas fa-computer-classic" @click="copyToClassicQuote">Copy To Classic Quote</ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-computer-classic" @click="copyToClassicMaterialsList">Copy To Classic Materials List</ui-dropdown-item>
                    </template>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item danger icon="fa fa-trash" @click="deleteEstimate">Delete</ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'

export default {
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
    },
    methods: {
        deleteEstimate () {
            this.$modals.confirmDelete({
                title: `Delete estimate #${this.estimate.id}`,
                button: 'Yes, delete estimate',
                handle: async () => {
                    await this.estimate.delete()
                    window.location = route('mobile.packages.estimates', this.estimate.package_dd.value)
                }
            })
        },
        async copyToClassicQuote () {
            this.$modals.confirm({
                title: `Copy estimate #${this.estimate.id} as a quote in Classic`,
                button: 'Yes, copy to Classic',
                handle: async () => {
                    const data = await this.estimate.copyToClassicQuote()
                    window.open(data._links.classic.view, '_blank').focus()
                }
            })
        },
        async copyToClassicMaterialsList () {
            this.$modals.confirm({
                title: `Copy estimate #${this.estimate.id} as a material list in Classic`,
                button: 'Yes, copy materials to Classic',
                handle: async () => {
                    const data = await this.estimate.copyToClassicMaterialsList()
                    window.open(data._links.classic.view, '_blank').focus()
                }
            })
        },
        async unsecureEstimate (close) {
          close()
          await this.estimate.clearAcceptanceOrDeclineStatus()

        },
        async undeclineEstimate (close) {
          close()
          await this.estimate.clearAcceptanceOrDeclineStatus()

        },
        async secureEstimate (close) {
            close()
            await this.estimate.secure()

        },
        async declineEstimate (close) {
            close()
            await this.estimate.decline()

        },
        createRemoteInvite (closeDropdown) {
            const nonCcInvites = this.$store.state.remoteInvites.filter(invite => ! invite.cc)
            const latestInvite = nonCcInvites.length > 0 ? nonCcInvites[nonCcInvites.length - 1] : null
            const defaultRecipient = { name: '', email: '' }
            const defaultCcRecipients = []

            if (latestInvite) {
                defaultRecipient.email = latestInvite.email
            } else if (this.estimate.client_email) {
                defaultRecipient.email = this.estimate.client_email
                defaultRecipient.name = this.estimate.client_name
            }

            this.$modals.open('remote-invite-create-modal', {
                type: 'estimate',
                identifier: this.estimate.id,
                onCreated: (newInvites, close) => {
                    newInvites.forEach(invite => {
                        this.$store.state.remoteInvites.push(invite)
                    })
                    this.estimate.locked = true
                    this.estimate.cannot_be_edited_by_authed_user = true
                    this.estimate.can_be_edited_by_authed_user = false
                    close()
                    this.checkIfPackageStatusNeedsToBeQuoted()
                },
                initialData: {
                    recipient: defaultRecipient,
                    cc_recipients: defaultCcRecipients,
                    subject: `${this.estimate.package} > Estimate #${this.estimate.id}`,
                },
            })
            closeDropdown()
        },
        checkIfPackageStatusNeedsToBeQuoted () {
            if (this.estimate.package_status < 300) {
                this.$modals.confirm({
                    title: 'Update package status to "Quoted"',
                    paragraphs: ["Since you've sent the estimate to someone, would you like to update the status of this package to \"Quoted\"?"],
                    button: 'Yes, Update Project Status',
                    handle: async () => {
                        await Http.put(route('api.v1.packages.update-status', this.estimate.package_id), { status_id: 300 })
                        window.location.reload();
                    },
                })
            }
        },
    },
}
</script>
